import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom"; import "./click.css";
import Select from "react-select";
import axiosConfig from "../../Service/AxiosConfig";
const specialityOptionsList = [
  { value: "General", label: "General" },
  { value: "Cardiology", label: "Cardiology" },
  { value: "Neurology", label: "Neurology" },
  { value: "Orthopaedics", label: "Orthopaedics" },
  { value: "Gynaecology", label: "Gynaecology" },
  { value: "Paediatrics", label: "Paediatrics" },
  { value: "Dermatology", label: "Dermatology" },
  { value: "Ent", label: "ENT" },
  { value: "Ophthalmology", label: "Ophthalmology" },
  { value: "Psychiatry", label: "Psychiatry" },
  { value: "Urology", label: "Urology" },
  { value: "Gastroenterology", label: "Gastroenterology" },
  { value: "Oncology", label: "Oncology" },
  { value: "Endocrinology", label: "Endocrinology" },
  { value: "Nephrology", label: "Nephrology" },
  { value: "Rheumatology", label: "Rheumatology" },
  { value: "Pulmonology", label: "Pulmonology" },
  { value: "General Surgery", label: "General Surgery" },
  { value: "Plastic Surgery", label: "Plastic Surgery" },
  { value: "Trauma Surgery", label: "Trauma Surgery" },
  { value: "Vascular Surgery", label: "Vascular Surgery" },
  { value: "Bariatric Surgery", label: "Bariatric Surgery" },
  { value: "Thoracic Surgery", label: "Thoracic Surgery" },
  { value: "Cardiothoracic Surgery", label: "Cardiothoracic Surgery" },
  { value: "Pediatric Surgery", label: "Pediatric Surgery" },
  { value: "Transplant Surgery", label: "Transplant Surgery" },
  { value: "Colorectal Surgery", label: "Colorectal Surgery" },
  { value: "Hepatobiliary Surgery", label: "Hepatobiliary Surgery" },
  { value: "Neurosurgery", label: "Neurosurgery" },
  { value: "Spine Surgery", label: "Spine Surgery" },
];

function Justaclickaway({ layout }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    speciality: null,
    date: "",
    time: "",
  });
  const [errors, setErrors] = useState("");
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location]);

  const isHomePage = location.pathname === "/";
  const containerStyle = {
    backgroundColor: isHomePage ? "#F5F7FA" : "#1D808C",
    padding: "5px 10px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };


  const handleSelectChange = (selectedOption) => {
    setFormData({ ...formData, speciality: selectedOption });
  };
  useEffect(() => {
    if (message || errors) {
      const timer = setTimeout(() => {
        setMessage("");
        setErrors("");
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [message, errors]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrors("");
    setMessage("");
    console.log("Form Submitted:", {
      ...formData,
      speciality: formData.speciality?.value || null,
    });
    const FormDataToSend = new FormData();
    FormDataToSend.append("name", formData.name);
    FormDataToSend.append("email", formData.email);
    FormDataToSend.append("mobile", formData.mobile);
    FormDataToSend.append("speciality", formData.speciality?.value || null);
    FormDataToSend.append("date", formData.date);
    FormDataToSend.append("time", formData.time);
    axiosConfig
      .post("blogapp/query/", FormDataToSend)
      .then((res) => {
        setMessage("Form Submitted Successfully!");
        setFormData({
          name: "",
          email: "",
          mobile: "",
          speciality: null,
          date: "",
          time: "",
        });
      })
      .catch((err) => {
        console.log(err, "errorkjhgf");
        let error = err?.response?.data?.error;
        setErrors(error);
      });
  };

  return (
    <div id="appointment-section" className="click-container" style={containerStyle}>
      <form onSubmit={handleSubmit}>
        <h2>Your Health, Just a Click Away</h2>
        <div className={`form-container ${layout === "single" ? "blogpage" : ""}`}>
          <div className="input-container">
            <label>Your Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="input-container">
            <label>Email Address</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="input-container">
            <label>Phone Number</label>
            <input
              type="tel"
              name="mobile"
              pattern="[0-9]{10}"
              maxLength="10"
              value={formData.mobile}
              onChange={handleChange}
              required
            />
          </div>
          <div className="input-container">
            <label>Choose Speciality</label>
            <Select
              name="speciality"
              options={specialityOptionsList}
              value={formData.speciality}
              onChange={handleSelectChange}
              placeholder="Select Speciality"
              isClearable
              required
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: '41px',
                  height: '41px',
                  backgroundColor: "#f0faff"
                }),
                valueContainer: (base) => ({
                  ...base,
                  height: '41px',
                  padding: '0 10px',
                }),
                indicatorsContainer: (base) => ({
                  ...base,
                  height: '41px',
                }),
              }}
            />

          </div>
          <div className="input-container">
            <label>Date</label>
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              required
            />
          </div>
          <div className="input-container">
            <label>Time</label>
            <input
              type="time"
              name="time"
              value={formData.time}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <button type="submit">Submit</button>
        {(message || errors) && (
          <p
            className="message-form"
            style={{ color: message ? "green" : "red" }}
          >
            {message || errors}
          </p>
        )}
      </form>
    </div>
  );
}

export default Justaclickaway;
